import React from 'react';
import LocationTemplate from './LocationTemplate';

const PineLevelPage: React.FC = () => {
  return (
    <LocationTemplate
      cityName="Pine Level"
      stateName="North Carolina"
      countyName="Johnston"
      zipCodes={["27568"]}
      latitude={35.5068}
      longitude={-78.2467}
      population={2051}
      historicalFact="Named for the area's pine forests, founded as a rural agricultural community."
      nearbyTowns={[
        "Selma, NC",
        "Four Oaks, NC",
        "Princeton, NC",
        "Micro, NC",
        "Smithfield, NC",
        "Clayton, NC",
        "Archer Lodge, NC",
        "Wendell, NC"
      ]}
    />
  );
};

export default PineLevelPage;